import React from "react";
import { Button } from "MODULES/shared/components";
import { API_BASE } from "APP_ROOT/constants";
import { stringify } from "query-string";

const ExportButton = ({ searchProps }) => {
  const params = searchProps.paginator.get("filters").toJS();

  return (
    <Button
      onClick={() =>
        window.open(
          `${API_BASE}/shopping_lists/export?${stringify(params)}`,
          "_blank"
        )}
    >
      Export
    </Button>
  );
};

export default ExportButton;



// WEBPACK FOOTER //
// ./app/modules/MyShoppingList/Search/ExportButton.jsx